import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OrderUserProfileFilter } from '@order/const';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { OnlineOrdersListComponentService } from '../online-orders-list.component-service';

@Component({
  selector: 'sd-online-orders-filter',
  templateUrl: './online-orders-filter.component.html',
  styleUrls: ['./online-orders-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgTemplateOutlet, SdvorButtonComponent],
})
export class OnlineOrdersFilterComponent {
  orderUserProfileFilter = OrderUserProfileFilter;
  selectedFilterValue$ = this.onlineOrdersListComponentService.getOrderUserProfileFilter();

  constructor(private onlineOrdersListComponentService: OnlineOrdersListComponentService) {}

  onClickFilter(value: OrderUserProfileFilter): void {
    this.onlineOrdersListComponentService.setOrderUserProfileFilter(value);
  }
}
